module.exports = "<ld-loading></ld-loading>\n<router-outlet></router-outlet>";


//////////////////
// WEBPACK FOOTER
// ./app/components/app/app.component.html
// module id = 1000
// module chunks = 0